module.exports = __webpack_public_path__ + "static/images/solution.f3d1fe05510308ba636a56f4c0f97024.jpg";